export const REFERRAL_QUERY_KEYS = {
  all: ['referral'] as const,
  members: (customerId: string) => ['referral', 'member', customerId] as const,
  country: (customerId: string) => ['referral', 'country', customerId] as const,
  ensure: (customerId: string) => ['referral', 'ensure', customerId] as const,
  ensureCountry: (customerId: string, country: string) => ['referral', 'ensure', customerId, country] as const,
  config: (country: string) => ['referral', 'config', country] as const,
  member: (customerId: string, country: string) => ['referral', 'member', customerId, country] as const,
  stats: (customerId: string, currency: string) => ['referral', 'stats', customerId, currency] as const,
};
